<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "Separator" });
export let label = "OR";
</script>

<div class="s8-separator-container">
    {#if label.trim() === ''}
        <div class="s8-separator-line"></div>
    {:else}
        <div class="s8-separator-text">
            <span>{label.trim()}</span>
        </div>
    {/if}
</div>

<style>

    :root {
        --s8-separator-color: rgba(211, 211, 211, 0.678);
    }
    div.s8-separator-container {
        margin: 10px 0;
    }
    div.s8-separator-container div.s8-separator-line {
            height: 1px;
            background-color: var(--s8-separator-color);
        }
    div.s8-separator-container div.s8-separator-text {
            display: flex;
            align-items: center;
        }
    div.s8-separator-container div.s8-separator-text span {
                color: rgba(128, 128, 128, 0.63);
            }
    div.s8-separator-container div.s8-separator-text::before,
        div.s8-separator-container div.s8-separator-text::after {
            content: '';
            flex-grow: 1;
            height: 1px;
            background-color: var(--s8-separator-color);
        }
    div.s8-separator-container div.s8-separator-text::before {
            margin-right: 10px;
        }
    div.s8-separator-container div.s8-separator-text::after {
            margin-left: 10px;
        }</style>